import { defineStore } from "pinia";
import { notify } from "@kyvg/vue3-notification";
import { API_CUPONERA, API_NOTIFICATIONS } from "../../helpers/axios";

export type couponState = {
    busqueda: string;
    error: string;
    campaingId: string;
    campaingValid: string;
    couponMileage: [];
    menssage: string;
    emailUser: string;
    code: string;
    status: string | number;
    campaingName: string;
    loading: boolean;
};

export const useCouponStore = defineStore({
    id: "coupon",
    state: (): couponState => ({
        busqueda: "",
        error: "",
        campaingId: "",
        campaingValid: "",
        couponMileage: [],
        menssage: "",
        emailUser: "",
        code: "",
        status: "",
        campaingName: "",
        loading: false,
    }),

    actions: {
        /**
         * Función para obtener una campaña en especifico por su id, consultando al servicio.
         * El resultado se almacena en variable del store
         * @returns {void}
         */
        async validateCampaingbyId(id: string): Promise<void> {
            this.loading = true;
            try {
                const response = await API_CUPONERA("/customer/campaign/id/" + id, {
                    method: "GET",
                });
                if (
                    response.data.data.campaign.downloaded <
                        response.data.data.campaign.limitation &&
                    response.data.data.campaign.campaign_status.description === "Activa"
                ) {
                    if (
                        response.data.data.campaign.brand_id === import.meta.env.VITE_BRAND_ID ||
                        response.data.data.campaign.brand_id === import.meta.env.VITE_BRAND_VWC
                    ) {
                        console.log("1");
                        this.campaingValid =
                            response.data.data.campaign.campaign_status.description;
                        this.menssage = "";
                        this.couponMileage = response.data.data.campaign.mileage;
                        localStorage.setItem("campaing_id", id);
                        localStorage.setItem("brand_id", response.data.data.campaign.brand_id);
                        localStorage.setItem(
                            "responseBrandId",
                            response.data.data.campaign.brand_id
                        );
                        this.loading = false;
                        return;
                    } else {
                        console.log("3");
                        this.campaingValid = "Inactiva";
                        this.menssage = "La campaña no pertenece a la marca";
                        this.loading = false;
                        return;
                    }
                } else {
                    console.log("2");
                    this.campaingValid = "Inactiva";
                    this.menssage = "La campaña ha finalizado o no existe";
                    this.loading = false;
                    return;
                }
            } catch (error: any) {
                if (error.response.status === 400) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, url o datos desconocidos.",
                    });
                    this.campaingValid = "Error";
                    this.status = 400;
                    this.loading = false;
                }
                if (error.response.status === 500) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, error en el servicio.",
                    });
                    this.campaingValid = "Error";
                    this.status = 500;
                    this.loading = false;
                }
            }
        },

        validateCoupon: async (_correo: string, _campaingId: string) => {
            try {
                const payload = { email: _correo, campaign_id: _campaingId };
                const coupon = await API_CUPONERA("/customer/bonus/validate", {
                    data: payload,
                    method: "POST",
                });
                if (coupon.status) {
                    localStorage.setItem("email", _correo);
                    return coupon.data;
                } else {
                    notify({
                        title: "Hubo un error",
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, el dato no existe.",
                    });
                }
            } catch (error) {
                throw new Error("No se pudo obtener el detalle del cupón, intenta más tarde.");
            }
        },
        createCoupon: async (campaign_id: string, dataPayload: any) => {
            try {
                const payload = {
                    campaign_id: campaign_id ?? localStorage.getItem("campaing_id"),
                    customer: dataPayload,
                    brand_id: localStorage.getItem("brand_id"),
                    created_by: "8d6bf2d2-3f16-49c4-9a82-440af2bcb937",
                };
                const coupon = await API_CUPONERA("/customer/bonus", {
                    data: payload,
                    method: "POST",
                });
                if (coupon.status) {
                    API_NOTIFICATIONS("/mail/raw", {
                        data: coupon.data.data.mail_request,
                        method: "POST",
                    }).catch(() => {
                        notify({
                            title: "Hubo un error al enviar el correo",
                            type: "error",
                            text: "No se pudo enviar el correo.",
                        });
                    });
                    localStorage.clear();
                    return coupon.data.data.bonus;
                } else {
                    notify({
                        title: "Hubo un error",
                        type: "error",
                        text: "No se pudo crear el cupón, el dato no existe.",
                    });
                }
            } catch (error: any) {
                notify({
                    title: `Error ${error.response.status}`,
                    type: "error",
                    text: "No se pudo crear el cupón, será redirigido al inicio.",
                });
                setTimeout(async function () {
                    window.location.href = `/home/${localStorage.getItem("campaing_id")}`;
                }, 2000);
                throw new Error("No se pudo crear el cupón, intenta más tarde.");
            }
        },
        setCampaing(id: string): void {
            this.campaingId = id;
        },
        setEmail(email: string): void {
            this.emailUser = email;
        },
        setCodeCoupon(code: string): void {
            this.code = code;
        },
        setCampaingName(name: string): void {
            this.campaingName = name;
        },
    },

    getters: {
        propFilter: (state: couponState) => {
            return state;
        },
    },
});
